export const joinStrings = (...arr: string[]) => arr.filter(x => !!x)?.join(',') || "";